import { render, staticRenderFns } from "./RegistrationSearchPagination.vue?vue&type=template&id=040bd4cd&"
import script from "./RegistrationSearchPagination.vue?vue&type=script&lang=js&"
export * from "./RegistrationSearchPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports